module.exports = new __parcel__URL__("cats-icon.8c9e32fe.svg").toString();